const enc = new TextDecoder("utf-8")

const uncompressSnappy = (data) => {
    // eslint-disable-next-line no-undef
    const uncompressSnappy = SnappyJS.uncompress(data)
    // return arrayBufferToString(uncompressSnappy)
    if (!("TextDecoder" in window))
        console.error("This browser does not support TextDecoder...")


    const arr = new Uint8Array(uncompressSnappy)
    return JSON.parse(enc.decode(arr))
}

export {
    uncompressSnappy
}
